// extracted by mini-css-extract-plugin
export var button = "slider-arrows-module--button--cqs+S";
export var left = "slider-arrows-module--left--9k2Rv";
export var separator = "slider-arrows-module--separator--mHJ+Z";
export var sliderArrows = "slider-arrows-module--slider-arrows--8w3SV";
export var spread = "slider-arrows-module--spread--HYYd0";